/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

export default angular.module('tektelic.api.converter', [])
    .factory('converterService', ConverterService)
    .name;

/*@ngInject*/
function ConverterService($http, $q) {

    var service = {
        deleteConverter: deleteConverter,
        getConverter: getConverter,
        saveConverter: saveConverter,
        getCustomerConverters: getCustomerConverters,
        getCustomerConvertersV1: getCustomerConvertersV1,
        getCustomerConvertersV2: getCustomerConvertersV2
    }

    return service;

    function getCustomerConverters () {
        var deferred = $q.defer();
        $http.get('/api/customer/converters', null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getCustomerConvertersV1 () {
        var deferred = $q.defer();
        $http.get('/api/customer/convertersv1', null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getCustomerConvertersV2 () {
        var deferred = $q.defer();
        $http.get('/api/customer/convertersv2', null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getConverter (converterId) {
        var deferred = $q.defer();
        var url = '/api/converter/' + converterId;
        $http.get(url, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function saveConverter (converter) {
        var deferred = $q.defer();
        var url = '/api/converter';
        $http.post(url, converter).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function deleteConverter (converterId) {
        var deferred = $q.defer();
        var url = '/api/converter/' + converterId;
        $http.delete(url).then(function success() {
            deferred.resolve();
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

}



// WEBPACK FOOTER //
// ./src/app/api/converter.service.js